<template>
  <modal-component
    :is-displayed="isEditModalOpened"
    :no-padding="true"
    :title="$t('Notification.EditTitle')"
    @toggle-modal="$emit('toggle-modal')"
  >
    <form @submit.prevent="handleSubmit">
      <form-wrapper :is-form-in-modal="true">
        <form-divider>
          <input-field
            v-model="notification.email"
            :error-message="v$?.notification['email']?.$errors[0]?.$message"
            :is-error="v$?.notification['email']?.$error"
            :label="$t('Notification.Email')"
            :required="true"
          />
          <checkbox-input
            v-model="notification.active"
            :is-checked="notification.active"
            :label="$t('Notification.Active')"
          />
        </form-divider>
        <button-wrapper :is-submit-loading="isSubmitLoading" />
      </form-wrapper>
    </form>
  </modal-component>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import ModalComponent from "@/core/Components/Modal.vue";
import FormWrapper from "@/core/Components/FormElements/FormWrapper.vue";
import FormDivider from "@/core/Components/FormElements/FormDivider.vue";
import ButtonWrapper from "@/core/Components/FormElements/ButtonWrapper.vue";
import InputField from "@/core/Components/FormElements/InputField.vue";
import CheckboxInput from "@/core/Components/FormElements/CheckboxInput.vue";
import { useToast } from "vue-toastification";
import { ErrorMessageFormatter } from "@/core/Services/GlobalFunctions";
import useValidate from "@vuelidate/core";
import { email, required } from "@vuelidate/validators";
import {
  Notifications,
  UpdateNotification,
} from "../Services/NotificationsTypes";
import NotificationsService from "../Services/NotificationsService";

export default defineComponent({
  components: {
    CheckboxInput,
    InputField,
    ButtonWrapper,
    FormDivider,
    FormWrapper,
    ModalComponent,
  },
  props: {
    isEditModalOpened: Boolean,
    selectedValue: {
      type: Object as PropType<Notifications>,
      required: true,
    },
    refreshData: {
      type: Function,
      required: true,
    },
  },
  emits: ["toggle-modal"],
  data() {
    return {
      isSubmitLoading: false,
      notification: {} as UpdateNotification,
      notificationsService: new NotificationsService(),
      toast: useToast(),
      v$: useValidate(),
    };
  },
  validations() {
    return {
      notification: {
        email: {
          required,
          email,
        },
      },
    };
  },
  created() {
    this.notification = JSON.parse(JSON.stringify(this.selectedValue));
  },
  methods: {
    async handleSubmit() {
      await this.v$.$validate();
      if (!this.v$.$error) {
        this.isSubmitLoading = true;
        try {
          await this.notificationsService.updateNotification(this.notification);
          this.toast.success((this as any).$t("Notification.EditSuccess"));
          this.$emit("toggle-modal");
          await this.refreshData();
        } catch (error) {
          (error as any).response.status == 400
            ? this.toast.error((error as any)?.response.data)
            : this.toast.error(ErrorMessageFormatter(error));
        } finally {
          this.isSubmitLoading = false;
        }
      }
    },
  },
});
</script>

<style scoped></style>
